"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var fastMemoize_1 = __importDefault(require("../../utils/fastMemoize"));
var BrandType_1 = require("../../types/enums/BrandType");
var utils_1 = __importDefault(require("../../utils"));
var Title_1 = require("../../utils/Title");
var utils_2 = require("../../utils/utils");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
var brandState = reselect_1.createSelector(moduleState, function (state) { return state.brandById; });
exports.brandIsLoading = reselect_1.createSelector(brandState, function (state) { return state.isLoading; });
exports.brandError = reselect_1.createSelector(brandState, function (state) { return state.error; });
exports.getBrand = reselect_1.createSelector(brandState, function (state) {
    return fastMemoize_1.default(function (brandId) { return state.data[brandId]; });
});
exports.getShow = reselect_1.createSelector(exports.getBrand, function (getBrandState) { return function (brandId) {
    var show = getBrandState(brandId);
    if ((show === null || show === void 0 ? void 0 : show.__typename) === BrandType_1.BrandType.Show) {
        return show;
    }
}; });
exports.getMovie = reselect_1.createSelector(exports.getBrand, function (getBrandState) { return function (brandId) {
    var movie = getBrandState(brandId);
    if ((movie === null || movie === void 0 ? void 0 : movie.__typename) === BrandType_1.BrandType.Movie) {
        return movie;
    }
}; });
exports.getShowEpisode = reselect_1.createSelector(exports.getBrand, function (getBrandState) { return function (brandId, episodeId) {
    var brand = getBrandState(brandId);
    if (utils_1.default.title.isShow(brand)) {
        var highlights = utils_1.default.pagination.getContent(brand.highlights);
        // check highlights firstly if it exists
        if (Array.isArray(highlights)) {
            var episode = highlights.find(function (_episode) { return (_episode === null || _episode === void 0 ? void 0 : _episode.id) === episodeId; });
            if (episode) {
                return episode;
            }
        }
        // check brand seasons
        return Title_1.findEpisode(brand.seasons, episodeId);
    }
}; });
exports.getSeasons = reselect_1.createSelector(brandState, function (state) { return function (brandId) {
    var brand = state.data[brandId];
    if ((brand === null || brand === void 0 ? void 0 : brand.__typename) === BrandType_1.BrandType.Show) {
        return brand.seasons;
    }
    return [];
}; });
var selectedSeasonState = reselect_1.createSelector(moduleState, function (state) { return state.selectedSeasonByBrandId; });
exports.getSelectedSeason = reselect_1.createSelector(exports.getBrand, selectedSeasonState, function (getBrandState, state) { return function (brandId) {
    var show = getBrandState(brandId);
    if (utils_2.isNilOrEmpty(show === null || show === void 0 ? void 0 : show.seasons)) {
        return undefined;
    }
    if (state[brandId]) {
        return show.seasons.find(function (season) { return (season === null || season === void 0 ? void 0 : season.id) === state[brandId]; });
    }
    // fall back to the first season if the defaultEpisode is not a VOD content.
    return (show.seasons.find(function (season) { var _a, _b; return (season === null || season === void 0 ? void 0 : season.id) === ((_b = (_a = show.defaultEpisode) === null || _a === void 0 ? void 0 : _a.season) === null || _b === void 0 ? void 0 : _b.id); }) || show.seasons[0]);
}; });
exports.showHighlights = reselect_1.createSelector(exports.getBrand, function (getBrandState) { return function (brandId) {
    var brand = getBrandState(brandId);
    if (utils_1.default.title.isShow(brand)) {
        return brand.highlights;
    }
    return [];
}; });
//# sourceMappingURL=selectors.js.map